module.exports = __webpack_public_path__ + "static/media/Settings_Divider@3x.f5b9bef3.png";